import React, { useEffect, useState } from "react";
import commonStyles from "@styles/CommonEditorPageLayout.module.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import Button from "@components/buttons/Button/Button";
import TextInput from "@components/inputs/TextInput/TextInput";
import { useAuth } from "@context/auth-context";
import { submitFuneralDirector } from "@services/memorialService";
import styles from "./PurchaseSuccessPage.module.css";

const PurchaseSuccessPage: React.FC = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const purchaseType = searchParams.get("purchaseType");
    const singleCredit = searchParams.get("singleCredit") === "true";
    // Set by the server for a standard user's upgrade of a traditional (non-pet) memorial
    const memorialId = searchParams.get("memorialId");
    const askFuneralDirector = searchParams.get("askFuneralDirector") === "true";
    const [funeralDirector, setFuneralDirector] = useState("");
    const { refreshUser } = useAuth();

    // The purchase conversion is sent by the server when Stripe confirms payment
    // (cloud server Stripe webhook), so it counts even if the buyer never reaches this page.

    // Get updated user data
    useEffect(() => {
        void refreshUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleFinish = async () => {
        const name = funeralDirector.trim();
        if (askFuneralDirector && memorialId && name) {
            try {
                await submitFuneralDirector(memorialId, name);
            } catch {
                // Optional answer: never hold the buyer up if it fails to save
            }
        }

        if (purchaseType === "subscription") {
            navigate("/upcoming-services", { replace: true });
        } else {
            await navigate("/memorials", { replace: true });
            if (singleCredit) {
                navigate("/memorials/editor?mode=add");
            }
        }
    };

    let message = "Success";
    let buttonText = "Begin";
    if (purchaseType === "subscription") {
        message = "Begin curating your online experience now!";
    } else if (purchaseType === "memorialCredits") {
        message = "Begin personalising your memorial now!";
    } else if (purchaseType === "candle") {
        message = "Your Forever Candle order was successful! Please check your email for order updates.";
        buttonText = "Finish";
    }

    return (
        <div className={commonStyles.container}>
            <h2>Purchase Successful!</h2>
            <div className={commonStyles.messageContainer}>
                <div className={styles.checkIcon}>
                    <CheckCircleOutlineIcon fontSize="inherit" />
                </div>
                <p>{message}</p>
                {askFuneralDirector && memorialId && (
                    <div className={styles.funeralDirector}>
                        <TextInput
                            id="funeral-director"
                            label="Who is your funeral director? (optional)"
                            value={funeralDirector}
                            onChange={setFuneralDirector}
                            placeholder="Funeral home or director's name"
                            onEnter={handleFinish}
                        />
                    </div>
                )}
                <div className={styles.buttonContainer}>
                    <Button onClick={handleFinish}>{buttonText}</Button>
                </div>
            </div>
        </div>
    );
};

export default PurchaseSuccessPage;
